var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_763_32)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0292 16.9742C26.6534 15.571 27 14.0195 27 12.3878C27 6.09847 21.8513 1 15.5 1C9.14873 1 4 6.09847 4 12.3878C4 13.719 4.23068 14.9969 4.65463 16.1844L4.63912 16.1838C4.68312 16.2896 4.72793 16.3958 4.77352 16.5022C4.90332 16.8338 5.04834 17.1578 5.20775 17.4735C7.55752 22.5254 11.5289 28.0675 15.5002 32.0001C19.8127 27.7297 24.3808 20.8971 26.0419 16.9746L26.0292 16.9742Z",
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0292 16.9742L25.5724 16.7709L25.2718 17.4465L26.0108 17.4738L26.0292 16.9742ZM4.65463 16.1844L4.63616 16.684L5.37365 16.7113L5.12552 16.0163L4.65463 16.1844ZM4.63912 16.1838L4.65758 15.6842L3.87786 15.6553L4.17744 16.3758L4.63912 16.1838ZM4.77352 16.5022L5.23912 16.3199L5.23623 16.3125L5.23311 16.3052L4.77352 16.5022ZM5.20775 17.4735L5.6611 17.2627L5.65771 17.2554L5.65408 17.2482L5.20775 17.4735ZM15.5002 32.0001L15.1484 32.3554L15.5002 32.7038L15.852 32.3554L15.5002 32.0001ZM26.0419 16.9746L26.5023 17.1696L26.7851 16.5017L26.0603 16.475L26.0419 16.9746ZM26.5 12.3878C26.5 13.948 26.1687 15.4304 25.5724 16.7709L26.4861 17.1774C27.1381 15.7116 27.5 14.0909 27.5 12.3878H26.5ZM15.5 1.5C21.5798 1.5 26.5 6.37923 26.5 12.3878H27.5C27.5 5.81772 22.1228 0.5 15.5 0.5V1.5ZM4.5 12.3878C4.5 6.37923 9.42023 1.5 15.5 1.5V0.5C8.87722 0.5 3.5 5.81772 3.5 12.3878H4.5ZM5.12552 16.0163C4.72055 14.8819 4.5 13.6609 4.5 12.3878H3.5C3.5 13.7772 3.74082 15.1119 4.18373 16.3525L5.12552 16.0163ZM4.62065 16.6835L4.63616 16.684L4.67309 15.6847L4.65758 15.6842L4.62065 16.6835ZM5.23311 16.3052C5.18821 16.2005 5.1441 16.096 5.10079 15.9918L4.17744 16.3758C4.22214 16.4833 4.26764 16.5911 4.31393 16.6991L5.23311 16.3052ZM5.65408 17.2482C5.50173 16.9464 5.36314 16.6367 5.23912 16.3199L4.30792 16.6844C4.44349 17.0308 4.59495 17.3692 4.76141 17.6989L5.65408 17.2482ZM15.852 31.6449C11.9204 27.7515 7.98444 22.2577 5.6611 17.2627L4.75439 17.6844C7.13061 22.7931 11.1374 28.3835 15.1484 32.3554L15.852 31.6449ZM25.5815 16.7796C23.9482 20.6364 19.4193 27.4157 15.1484 31.6449L15.852 32.3554C20.2062 28.0438 24.8134 21.1578 26.5023 17.1696L25.5815 16.7796ZM26.0108 17.4738L26.0234 17.4743L26.0603 16.475L26.0477 16.4745L26.0108 17.4738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 11.5548,
    rx: 6.57143,
    ry: 6.49524,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_763_32",
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 38.2036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_763_32"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_763_32",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/PIN.a5fb25cdb122af961e1b678c68ec0e4d.svg";
export { ForwardRef as ReactComponent };